var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fluid-container"},[_c('b-img',{staticClass:"pt-3 pb-4",attrs:{"fluid":"","center":"","src":require("@/assets/img/visma-logo.svg"),"alt":"Visma logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }